<template>
  <div
    class="overflow-x-auto scrollbar-hidden member-datatable"
    data-test="member-datatable"
  >
    <Datatable
      :api-params="paramsComputed"
      :api-url="'member/getMemberSurvey'"
      :method-request="'POST'"
      :data-array="dataArray"
      :data-array-table="dataArrayTable"
      :router-name="'member'"
      :key="key"
      :default-sort="[{ field: '_id', dir: 'desc' }]"
      :custom-sort="[
        { column: 'name', relateColumn: ['surname'] },
        {
          column: 'hnum',
          relateColumn: [
            'moo',
            'village_name',
            'soi',
            'road',
            'tumbol_name',
            'amphur_name',
            'province_name',
          ],
        },
      ]"
      @rowClick="
        router.push({ name: 'member-profile', params: { mid: $event._id } })
      "
    />
  </div>
</template>

<script>
import Datatable from "@/components/datatable/index.vue";
import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRouter } from "vue-router";
import OtherSystemList from "@/data/other_system_list.json";
// import axios from "axios"
export default defineComponent({
  props: {
    filter: {
      type: Object,
    },
  },
  components: {
    Datatable,
  },
  setup(props) {
    const dataArray = ref();
    const params = ref({ start: "1", draw: "1", length: "10" });
    const key = ref(1);
    const router = useRouter();
    watch(
      () => props.filter,
      () => {
        key.value++;
      }
    );
    const paramsComputed = computed(() => ({
      ...params.value,
      ...props.filter,
    }));
    var customNameMutator = (value, data, type, params, component) => {
      return `${data.title ? data.title : ""}${data.name ? data.name : ""} ${
        data.surname ? data.surname : ""
      } `;
    };
    var customAddressMutator = (value, data, type, params, component) => {
      return `${data.hnum ? data.hnum : ""} ${
        data.moo ? "หมู่ " + data.moo : ""
      } ${data.village_name ? data.village_name : ""} ${
        data.soi ? "ซอย " + data.soi : ""
      } ${data.road ? "ถนน " + data.road : ""} ${
        data.tumbol_name ? "ตำบล" + data.tumbol_name : ""
      }  ${data.amphur_name ? "อำเภอ" + data.amphur_name : ""} ${
        data.province_name ? "จังหวัด" + data.province_name : ""
      } ${data.postcode ? data.postcode : ""}`;
    };
    var customProblemMutator = (value, data, type, params, component) => {
      return {
        housing: data.prob_housing,
        health: data.prob_health,
        occupation: data.prob_occupation,
        education: data.prob_education,
        accessibility: data.prob_accessibility,
        family: data.prob_family,
        violence: data.prob_violence,
        human_trafficking: data.prob_human_trafficking,
        others: data.prob_others,
      };
    };
      var customLinkingSystemMutator = (value, data, type, params, component) => {
        console.log(data)
      return  data.linking_system
    };
    const systemMap = OtherSystemList.reduce((map, item) => {
    map[item.field] = item;
    return map;
}, {});
    const dataArrayTable = reactive([
      {
        title: "สมาชิก",
        field: "name",
        minWidth: 200,
        resizable: true,
        formatter: "textarea",
        mutator: customNameMutator,
      },
      {
        title: "ที่อยู่",
        field: "hnum",
        hozAlign: "left",
        minWidth: 200,
        resizable: true,
        formatter: "textarea",
        mutator: customAddressMutator,
      },
      {
        title: "สภาพปัญหา",
        field: "problems",
        minWidth: 400,
        mutator: customProblemMutator,
        variableHeight: true,
        formatter: function(cell, formatterParams) {
          var value = cell.getValue();
          let res = `<div class="flex flex-wrap"><button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${
            value.housing > 0
              ? "bg-theme-36 hover:bg-theme-36"
              : "bg-theme-37 hover:bg-theme-37"
          }'>\
                            <span class="t-tooltip-text">ที่อยู่อาศัย</span>\
                            <span class="img-icon map-pin-icon"></span>\
                        </button>\
                        <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${
                          value.health > 0
                            ? "bg-theme-36 hover:bg-theme-36"
                            : "bg-theme-37 hover:bg-theme-37"
                        }'>\
                            <span class="t-tooltip-text">สุขภาพอนามัย</span>\
                            <span class="img-icon heart-icon"></span>\
                        </button>\
                        <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${
                          value.education > 0
                            ? "bg-theme-36 hover:bg-theme-36"
                            : "bg-theme-37 hover:bg-theme-37"
                        }'>\
                            <span class="t-tooltip-text">การศึกษา</span>\
                            <span class="img-icon book-open-icon"></span>\
                        </button>\
                        <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${
                          value.occupation > 0
                            ? "bg-theme-36 hover:bg-theme-36"
                            : "bg-theme-37 hover:bg-theme-37"
                        }'>\
                            <span class="t-tooltip-text">การมีงานทำและมีรายได้</span>\
                            <span class="img-icon dollar-sign-icon"></span>\
                        </button>\
                        <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${
                          value.family > 0
                            ? "bg-theme-36 hover:bg-theme-36"
                            : "bg-theme-37 hover:bg-theme-37"
                        }'>\
                            <span class="t-tooltip-text">ครอบครัว</span>\
                            <span class="img-icon home-icon"></span>\
                        </button>\
                        <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${
                          value.violence > 0
                            ? "bg-theme-36 hover:bg-theme-36"
                            : "bg-theme-37 hover:bg-theme-37"
                        }'>\
                            <span class="t-tooltip-text">ความรุนแรงในครอบครัว/สังคม</span>\
                            <span class="img-icon glove-icon"></span>\
                        </button>\
                        <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${
                          value.human_trafficking > 0
                            ? "bg-theme-36 hover:bg-theme-36"
                            : "bg-theme-37 hover:bg-theme-37"
                        }'>\
                            <span class="t-tooltip-text">การเป็นผู้เสียหายจากการค้ามนุษย์</span>\
                            <span class="img-icon payment-icon"></span>\
                        </button>\
                        <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${
                          value.accessibility > 0
                            ? "bg-theme-36 hover:bg-theme-36"
                            : "bg-theme-37 hover:bg-theme-37"
                        }'>\
                            <span class="t-tooltip-text">การเข้าไม่ถึงสิทธิและความเป็นธรรมในสังคม</span>\
                            <span class="img-icon card-icon"></span>\
                        </button>\
                        <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${
                          value.others > 0
                            ? "bg-theme-36 hover:bg-theme-36"
                            : "bg-theme-37 hover:bg-theme-37"
                        }'>\
                            <span class="t-tooltip-text">สภาพปัญหาสังคมอื่นๆ</span>\
                            <span class="img-icon cloud-lightning-icon"></span>\
                        </button></div>`;
          return res;
        },
      },{
  title: "การเชื่อมโยงกับระบบอื่น",
  field: "linking_system",
  width: 250,
  mutator: customLinkingSystemMutator,
  variableHeight: true,
  formatter: function(cell, formatterParams) {
    // เปลี่ยนจาก null เป็น "" เพื่อไม่ให้มีคำว่า "null" แสดงบนหน้าเว็บ
    let res = ""; 
    let value = cell.getValue();
    
    if (Array.isArray(value) && value.length > 0) {
      res += '<div class="flex flex-wrap">';
      value.forEach((item) => {
        // ตรวจสอบว่า item เป็น Object หรือไม่ ถ้าใช่ให้ดึง .system ออกมา 
        // ถ้าไม่ใช่ (เป็น String แบบเก่า) ให้ใช้ค่า item ตรงๆ
        if (item) {
          const systemValue = (typeof item === 'object') ? item.system : item;
          const updatedAt = (typeof item === 'object') ? item.updated_at : null;

          let tooltipText = "";
          const systemInfo = systemMap[systemValue];

          if (systemInfo) {
            tooltipText = systemInfo.tooltipText;
            // วันที่อัปเดต อยากแสดงต่อท้ายชื่อระบบใน Tooltip
            if (updatedAt) {
              tooltipText += ` (ข้อมูล ณ วันที่: ${updatedAt})`;
            }
          } else {
            tooltipText = "ไม่พบข้อมูลระบบ";
          }

          if (systemValue) {
            res += `<button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-0 mb-1'>\
                      <span class="t-tooltip-text">${tooltipText}</span>\
                      <span class=""><img src="${require("@/assets/images/logo/" + systemValue + ".png")}"></span>\
                    </button>`;
          }
        }
      });
      res += '</div>';
    }
    return res;
  },
}
//       {
//         title: "การเชื่อมโยงกับระบบอื่น",
//         field: "linking_system",
//         width: 250,
//         mutator: customLinkingSystemMutator,
//         variableHeight: true,
//         formatter: function(cell, formatterParams) {
//           let res = null;
//         //  if(linking_system?.length > 0){
//         //   if(linking_system.includes('CSG')){
//         //         res += '<div class="flex flex-wrap">';
//         //          res += `<button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-0 mb-1'>\
//         //                     <span class="t-tooltip-text">ระบบเงินอุดหนุนเพื่อการเลี้ยงดูเด็กแรกเกิด กรมกิจการเด็กและเยาวชน</span>\
//         //                     <span class=""><img class="connection-tags" src="${require("@/assets/images/logo/CSG.png")}"></span>\
//         //                 </button>`;
//         //       res += '</div>';
//         //       }
//         //  }
//         let value = cell.getValue();
//         console.log(value)
//           if (Array.isArray(value) && value.length > 0) {
//             res += '<div class="flex flex-wrap">';
//             value.forEach((item) => {
//               if (item ) {
//                 const systemValue = item;
//                 let tooltipText = "";

//                 // if (systemValue === "VSMART") {
//                 //   tooltipText = "ระบบ พม.สมาร์ท สป.พม.";
//                 // } 
//                 const systemInfo = systemMap[systemValue];
// if (systemInfo) {
//     tooltipText = systemInfo.tooltipText;
// } else {
//     tooltipText = "ไม่พบข้อมูลระบบ"; 
// }
//                 if (tooltipText) {
//                   res += `<button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-0 mb-1'>\
//                             <span class="t-tooltip-text">${tooltipText}</span>\
//                             <span class=""><img src="${require("@/assets/images/logo/"+systemValue+".png")}"></span>\
//                         </button>`;
//                 }
//               }
//             });
//         res += '</div>';
//           }
//         //   if (iii.value != 1 && iii.value != 11) {
//         //     res += '<span class="text-gray-500">ยังไม่มีการเชื่อมโยงกับระบบอื่น</span>';
//         //   }

//           return res;
//         },
//       },
      // {title:"สถานะ", field:"status", hozAlign:"center", minWidth: 100,
      //     formatter:function(cell, formatterParams){
      //         console.log('cell')
      //         console.log(cell)
      //         if(cell.getValue() == "created"){
      //             return "รอตรวจสอบ"
      //         }
      //         else{
      //             return "รออนุมัติ"
      //         }
      //     }
      // },
      // {title:"จำนวนสมาชิก", field:"count", hozAlign:"center", resizable:false, minWidth: 200},
    ]);

    return {
      dataArrayTable,
      params,
      key,
      paramsComputed,
      dataArray,
      router,
    };
  },
});
</script>

<style lang="scss">
.member-datatable {
}
</style>
